import { useRef } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Logo from '../../../../new-components/ui/Logo';
import useMapActions from '../../hooks/MapActions';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

interface SearchResultCardProps {
  id: number;
  logoPath: string;
  compoundName: string;
  startPrice: number;
  isFiltered?: boolean;
}

const SearchResultCard = ({
  id,
  logoPath,
  compoundName,
  startPrice,
  isFiltered
}: SearchResultCardProps) => {
  const { t } = useTranslation(['common', 'map']);
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const { locale } = useRouter();

  const cardRef = useRef<HTMLDivElement | null>(null);

  const { selectCompound } = useMapActions();
  const filters = useSelector((state: any) => state.map.filters);

  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );

  const handleCardClick = () => {
    selectCompound(id);
  };
  return (
    <Container
      ref={cardRef}
      isSelected={id === selectedCompound?.id}
      onClick={handleCardClick}
      isFiltered={Object.keys(filters).length > 0 ? isFiltered : true}
    >
      <div className="logo">
        <Logo logoPath={logoPath} />
      </div>
      <div className="card-details">
        <h2>{compoundName}</h2>

        {startPrice && startPrice > 0 ? (
          <span className="price">
            {`${Intl.NumberFormat(locale, {
              minimumFractionDigits: startPrice % 1000000 === 0 ? 0 : 1,
              maximumFractionDigits: 1
            }).format(startPrice / 1000000)} ${t('million', {
              ns: 'map'
            })}`}
            {!(isMobile && locale === 'ar') && (
              <span className="start-price">{t('start_price')}</span>
            )}
          </span>
        ) : (
          <></>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div<{ isSelected: boolean; isFiltered?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 8px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f1f3;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;
  background-color: ${props => (props.isFiltered ? '#fff' : '#e0e0e0')};
  .logo {
    min-width: 48px;
    min-height: 48px;
    width: 48px;
    height: 48px;
  }

  .card-details {
    display: flex;
    align-items: start;
    flex-direction: column;
    color: #2c3138;
    overflow: hidden;

    h2 {
      max-width: 100%;
      font-size: 16px;
      font-family: materialBold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .price {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      font-family: materialBold;

      .start-price {
        font-size: 11px;
        color: #697586;
        white-space: nowrap;
        font-size: 11px;
        font-family: materialRegular;
      }
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    min-width: 110px;
    width: 110px;
    padding: 8px 0;
    flex-direction: column;
    justify-content: center;

    .card-details {
      max-width: 95%;
      align-items: center;
      justify-content: center;
      h2 {
        font-size: 14px;
        font-family: materialMedium;
        text-align: center;
      }

      .price {
        font-size: 13px;

        .start-price {
          font-size: 10px;
        }
      }
    }
  }
`;

export default SearchResultCard;
